var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcVocabulary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2801 7.28125C14.3995 7.2286 14.5007 7.14209 14.5714 7.03245C14.6421 6.92281 14.679 6.79484 14.6777 6.6644C14.6763 6.53397 14.6367 6.40679 14.5638 6.29864C14.4909 6.19048 14.3879 6.10608 14.2674 6.05591L8.55344 3.45325C8.37973 3.37401 8.19104 3.33301 8.00011 3.33301C7.80918 3.33301 7.62048 3.37401 7.44678 3.45325L1.73344 6.05325C1.61475 6.10523 1.51379 6.19067 1.44289 6.29912C1.37199 6.40758 1.33423 6.53434 1.33423 6.66391C1.33423 6.79349 1.37199 6.92025 1.44289 7.0287C1.51379 7.13716 1.61475 7.2226 1.73344 7.27458L7.44678 9.87991C7.62048 9.95915 7.80918 10.0002 8.00011 10.0002C8.19104 10.0002 8.37973 9.95915 8.55344 9.87991L14.2801 7.28125Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 6.6665V10.6665",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.3335V10.6668C4 11.1973 4.42143 11.706 5.17157 12.081C5.92172 12.4561 6.93913 12.6668 8 12.6668C9.06087 12.6668 10.0783 12.4561 10.8284 12.081C11.5786 11.706 12 11.1973 12 10.6668V8.3335",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVocabulary);
export default __webpack_public_path__ + "static/media/ic_vocabulary.ba17215991c054a04ba73229ae888b0b.svg";
export { ForwardRef as ReactComponent };